module.exports = __webpack_public_path__ + "img/clue.095f55c1.png";